import axios from "axios";
import { TokenStorage } from "../types";

export class TokenRefreshService {
  constructor(
    private tokenStorage: TokenStorage,
    private refreshEndpoint: string
  ) {}

  async refreshToken(): Promise<string> {
    const refreshToken = this.tokenStorage.getRefreshToken();

    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    try {
      const response = await axios.post(this.refreshEndpoint, {
        refreshToken,
      });

      const { accessToken, refreshToken: newRefreshToken } = response.data;

      if (newRefreshToken) {
        this.tokenStorage.setRefreshToken(newRefreshToken);
      }

      return accessToken;
    } catch {
      throw new Error("Token refresh failed");
    }
  }
}
